import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VendorInfoComponent } from 'src/app/containers/vendor-info/vendor-info.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { OpportunitiesModule } from '../opportunities/opportunities.module';
import { ResourcesModule } from '../resources/resources.module';
import { SettingsModule } from '../settings/settings.module';
import { ProjectsContainerModule } from '../projects/projects.module';
import { CompanyListsRedirectGuard } from 'src/app/guards/company-list-redirect.guard';
import { MySuppliersModule } from '../my-suppliers/my-suppliers.module';
import { MyConnectionsModule } from '../my-connections/my-connections.module';
import { OpenSearchDiscoverModule } from '../discover/open-search-discover.module';
import { VendorModule } from 'sustainment-component';
import { EditProfileRedirectGuardGuard } from 'src/app/guards/edit-profile-redirect-guard.guard';
import { InternationalVendorGuard } from 'src/app/guards/international-vendor.guard';
import { RegistrationGuard } from 'src/app/guards/registration.guard';
import { NetworkGuard } from 'src/app/guards/network.guard';
import { PartsModule } from '../parts/parts.module';
import { AnalyiticsModule } from '../analytics/analytics.module';
import { DromoModule } from '../dromo/dromo.module';
import { DromoGuard } from 'src/app/guards/dromo.guard';
import { VendorPerformanceComponent } from './vendor-performance/vendor-performance.component';

const routes: Routes = [
  {
    path: '',
    component: VendorInfoComponent,
    canActivate: [RegistrationGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: (): Promise<typeof DashboardModule> =>
          import('../dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'chat',
        redirectTo: 'home'
      },
      {
        path: 'projects',
        loadChildren: (): Promise<typeof ProjectsContainerModule> =>
          import('../projects/projects.module').then(
            (m) => m.ProjectsContainerModule
          ),
        data: { feature: 'projects' }
      },
      {
        path: 'parts',
        loadChildren: (): Promise<typeof PartsModule> =>
          import('../parts/parts.module').then((m) => m.PartsModule)
      },
      {
        path: 'opportunities',
        loadChildren: (): Promise<typeof OpportunitiesModule> =>
          import('../opportunities/opportunities.module').then(
            (m) => m.OpportunitiesModule
          )
      },
      {
        path: 'orders',
        loadChildren: (): Promise<typeof OpportunitiesModule> =>
          import('../opportunities/opportunities.module').then(
            (m) => m.OpportunitiesModule
          )
      },
      {
        path: 'resources',
        loadChildren: (): Promise<typeof ResourcesModule> =>
          import('../resources/resources.module').then(
            (m) => m.ResourcesModule
          ),
        canActivate: [InternationalVendorGuard],
        data: { feature: 'resources' }
      },
      {
        path: 'network',
        loadChildren: (): Promise<typeof OpenSearchDiscoverModule> =>
          import('../../modules/discover/open-search-discover.module').then(
            (m) => m.OpenSearchDiscoverModule
          ),
        canActivate: [NetworkGuard]
      },
      {
        path: 'settings',
        loadChildren: (): Promise<typeof SettingsModule> =>
          import('../settings/settings.module').then((m) => m.SettingsModule),
        data: { feature: 'settings' }
      },
      {
        path: 'company-lists',
        redirectTo: 'suppliers',
        pathMatch: 'full'
      },
      {
        path: 'company-lists/:id',
        canActivate: [CompanyListsRedirectGuard],
        children: []
      },
      {
        path: 'project-performance/:sustainmentId/:companyName/:alias',
        component: VendorPerformanceComponent
      },
      {
        path: 'connections',
        loadChildren: (): Promise<typeof MyConnectionsModule> =>
          import('../my-connections/my-connections.module').then(
            (m) => m.MyConnectionsModule
          )
      },
      {
        path: 'suppliers',
        loadChildren: (): Promise<typeof MySuppliersModule> =>
          import('../my-suppliers/my-suppliers.module').then(
            (m) => m.MySuppliersModule
          )
      },
      {
        path: 'analytics',
        loadChildren: (): Promise<typeof AnalyiticsModule> =>
          import('../analytics/analytics.module').then(
            (m) => m.AnalyiticsModule
          )
      },
      {
        path: 'customers',
        loadChildren: (): Promise<typeof MySuppliersModule> =>
          import('../my-suppliers/my-suppliers.module').then(
            (m) => m.MySuppliersModule
          )
      },
      {
        path: 'preview-profile',
        canActivate: [EditProfileRedirectGuardGuard],
        children: []
      },
      {
        path: 'my-profile',
        canActivate: [EditProfileRedirectGuardGuard],
        children: []
      },
      {
        path: 'profile/:id',
        loadChildren: (): Promise<typeof VendorModule> =>
          import('sustainment-component').then((m) => m.VendorModule)
      },
      {
        path: 'dromo',
        loadChildren: (): Promise<typeof DromoModule> =>
          import('../dromo/dromo.module').then((m) => m.DromoModule),
        canActivate: [DromoGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorInfoRoutingModule {}
